// extracted by mini-css-extract-plugin
module.exports = {"trix_container":"index_trix_container_2Hg3E","trix-button-group":"index_trix-button-group_3drSL","trix-content":"index_trix-content_2s3QV"};